import random from 'toxilibs/random.js'
import Level from '../core/level.js'
import mathText from '../math_text.js'

const level = new Level({
    name: 'pythagorean_with_root',
    dependencies: [
        'levels_maths/pythagorean_theorem',
        'levels_maths/int_square_root'
    ]
})



function common (q, params) {
    params = params || {}

    let ab = random.fairChoiceInt(1, 5, {name: 'ab'})
    let ac = random.fairChoiceInt(1, 5, {name: 'ac'})

    let geoScreen = q.addGeoScreen({
        noAxes: true,
        maxScale: 1000
    })

    let points = {
        a: {x: 0,  y: 0,  name: 'A', color: '#F00'},
        b: {x: ab, y: 0,  name: 'B', color: '#226ea5'},
        c: {x: 0,  y: ac, name: 'C', color: '#390'}
    }

    geoScreen.addPolygon({
        points: [points.a, points.b, points.c],
        color: '#666'
    })

    if (!params.noSquaresInText) {
        q.addText('carre(' + mathText.pointsDistance(points.a, points.b) + ') = ' + (ab * ab))
        q.addText('carre(' + mathText.pointsDistance(points.a, points.c) + ') = ' + (ac * ac))
    }

    q.addText(mathText.pointsDistance(points.b, points.c) + ' = ?')
    q.answer = [
        'racine(' + (ab * ab + ac * ac) + ')',
        q.approximation(Math.sqrt(ab * ab + ac * ac), 0.1)
    ]
}


level.addQuestion({
    generator: function (q) {
        common(q)
    },
    errorExpected: true,
    times: 2
})


level.addQuestion({
    generator: function (q) {
        common(q, {noSquaresInText: true})
    }
})


export default level

